/* SANTO motion: headline reveal + grid stagger */
(function () {
  if (window.__santoMotion) return; window.__santoMotion = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (reduce || !hasIO) return;

  /* 1. Headline reveal */
  function splitHeading(h) {
    if (h.dataset.smSplit) return; h.dataset.smSplit = '1';
    var full = h.textContent.replace(/\s+/g, ' ').trim(); if (!full) return;
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            var wrap = document.createElement('span'); wrap.className = 'sm-w-wrap';
            var w = document.createElement('span'); w.className = 'sm-w'; w.style.setProperty('--sm-i', i++); w.textContent = p;
            wrap.appendChild(w); frag.appendChild(wrap);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    }
    walk(h);
    h.setAttribute('aria-label', full);
    Array.prototype.forEach.call(h.children, function (c) { c.setAttribute('aria-hidden', 'true'); });
    h.classList.add('sm-split');
  }
  var headIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('sm-in'); headIO.unobserve(e.target); } });
  }, { threshold: 0.2 });
  function initHeads(root) {
    (root || document).querySelectorAll('.glfs-hero__heading').forEach(function (h) {
      if (h.dataset.smSplit) return;
      splitHeading(h);
      h.getBoundingClientRect(); // commit hidden state before observing
      requestAnimationFrame(function () { headIO.observe(h); });
    });
  }

  /* 3. Grid stagger */
  var CARD_SEL = '.glfs-drop-grid .card-wrapper, .glfs-drop-grid__item, .glfs-drop-grid li, [class*="tabs-collection"] .grid__item, [class*="tabs-collection"] .card-wrapper, .product-grid .grid__item';
  var batch = [], flushT;
  var cardIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { batch.push(e.target); cardIO.unobserve(e.target); } });
    clearTimeout(flushT);
    flushT = setTimeout(function () {
      batch.sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
      batch.forEach(function (el, k) { el.style.setProperty('--sm-d', Math.min(k, 10)); el.classList.add('sm-in'); });
      batch = [];
    }, 16);
  }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
  function inView(el) { var r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0 && r.left < innerWidth && r.right > 0; }
  function initCards(root) {
    (root || document).querySelectorAll(CARD_SEL).forEach(function (el) {
      if (el.dataset.smCard) return;
      if (el.parentElement && el.parentElement.closest('[data-sm-card]')) return; // no nested double
      el.dataset.smCard = '1';
      // skip theme-animated items and anything already visible at load
      if (el.classList.contains('scroll-trigger') || el.querySelector('.scroll-trigger.animate--slide-in')) return;
      if (!booted && inView(el)) return;
      el.classList.add('sm-card');
      cardIO.observe(el);
    });
  }

  var booted = false;
  function run(root) { initHeads(root); initCards(root); }
  function start() {
    run(document); booted = true;
    new MutationObserver(function (ms) {
      var hit = false;
      ms.forEach(function (m) { if (m.addedNodes.length) hit = true; });
      if (hit) { clearTimeout(start._t); start._t = setTimeout(function () { run(document); }, 30); }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();